import React, { useState } from "react";
import { Loader2, Download } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export const LeadGate = ({ open, onClose, onDone, api }) => {
  const [f, setF] = useState({ name: "", whatsapp: "", city: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (f.name.trim().length < 2) return toast.error("Please enter your name");
    if (!/^\+?[0-9 ]{10,15}$/.test(f.whatsapp.trim())) return toast.error("Please enter a valid WhatsApp number");
    setBusy(true);
    try {
      await api.post("/catalogue-leads", { ...f, whatsapp: f.whatsapp.trim() });
      localStorage.setItem("skd_catalogue_lead", "1");
      toast.success("Thank you! Your catalogue is ready.");
      onDone();
    } catch {
      toast.error("Could not continue. Please check your details.");
    } finally { setBusy(false); }
  };
  const inp = "bg-[#120A07] border-[#3B251D] text-[#FDFBF7] h-12";
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-[#1A0F0B] border-[#3B251D] text-[#FDFBF7] max-w-md" data-testid="lead-gate-dialog">
        <DialogTitle className="font-display text-2xl">Get the SCHOKODALE Catalogue</DialogTitle>
        <DialogDescription className="text-[#8C7B6E] text-sm">Share your details and we'll unlock the full 24-page catalogue instantly.</DialogDescription>
        <form onSubmit={submit} className="grid gap-3 mt-2">
          <Input data-testid="lead-name" placeholder="Your name *" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className={inp} />
          <Input data-testid="lead-whatsapp" placeholder="WhatsApp number *" inputMode="tel" value={f.whatsapp} onChange={(e) => setF({ ...f, whatsapp: e.target.value })} className={inp} />
          <Input data-testid="lead-city" placeholder="City (optional)" value={f.city} onChange={(e) => setF({ ...f, city: e.target.value })} className={inp} />
          <Button type="submit" disabled={busy} data-testid="lead-submit-btn" className="btn-gold rounded-full h-12 mt-1">
            {busy ? <Loader2 className="animate-spin" size={18} /> : <><Download size={16} className="mr-2" /> Unlock Catalogue</>}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
